export default "__VITE_ASSET__01f8bded__"